const cards = [
  {
    id: 1,
    title: '香蕉视频 · 动作猛片专区',
    desc: '硬汉专属动作大片合集，拳拳到肉、全程高能，每周更新 50+ 部精选影片。',
    icon: 'ri-sword-line',
    color: 'primary',
  },
  {
    id: 2,
    title: '红桃视频 · 悬疑烧脑剧场',
    desc: '高评分悬疑推理剧全收录，反转不断、烧脑过瘾，追到停不下来。',
    icon: 'ri-mental-health-line',
    color: 'accent',
  },
  {
    id: 3,
    title: '蜜桃视频 · 午夜限时频道',
    desc: '每晚 22:00 准时开放，精选午夜专场内容，限时观看、错过等明天。',
    icon: 'ri-moon-line',
    color: 'secondary',
  },
  {
    id: 4,
    title: '樱花视频 · 综艺爆笑合集',
    desc: '最新综艺全季收录，搞笑不断、下饭必备，周末宅家一口气刷完。',
    icon: 'ri-emotion-laugh-line',
    color: 'primary',
  },
  {
    id: 5,
    title: '动漫番剧 · 周更追番指南',
    desc: '当季热门动漫番剧全收录，同步更新、高清画质，二次元宅男的天堂。',
    icon: 'ri-ghost-line',
    color: 'accent',
  },
  {
    id: 6,
    title: '经典港片 · 高清修复馆',
    desc: '经典香港电影高清修复版全系列，重温黄金年代，情怀拉满。',
    icon: 'ri-film-line',
    color: 'secondary',
  },
  {
    id: 7,
    title: '热门合集 · 一网打尽',
    desc: '跨平台热门内容智能聚合，根据热度排序，快速定位全网最火视频。',
    icon: 'ri-fire-line',
    color: 'primary',
  },
];

const colorMap: Record<string, { bg: string; icon: string; hover: string }> = {
  primary: { bg: 'bg-primary-50', icon: 'text-primary-600', hover: 'hover:border-primary-200' },
  accent: { bg: 'bg-accent-50', icon: 'text-accent-600', hover: 'hover:border-accent-200' },
  secondary: { bg: 'bg-secondary-50', icon: 'text-secondary-600', hover: 'hover:border-secondary-200' },
};

export default function Cards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <h2 className="section-title">精选推荐</h2>
        <p className="section-subtitle">按频道分类浏览，快速找到你感兴趣的内容方向</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mt-10">
          {cards.slice(0, 4).map((card) => {
            const colors = colorMap[card.color];
            return (
              <div
                key={card.id}
                className={`bg-background-50 border border-background-200/70 rounded-xl p-5 cursor-pointer transition-colors ${colors.hover}`}
              >
                <div className={`w-12 h-12 rounded-xl ${colors.bg} flex items-center justify-center mb-4`}>
                  <i className={`${card.icon} ${colors.icon} text-xl`}></i>
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            );
          })}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 mt-4 md:mt-5">
          {cards.slice(4).map((card) => {
            const colors = colorMap[card.color];
            return (
              <div
                key={card.id}
                className={`bg-background-50 border border-background-200/70 rounded-xl p-5 cursor-pointer transition-colors ${colors.hover}`}
              >
                <div className={`w-12 h-12 rounded-xl ${colors.bg} flex items-center justify-center mb-4`}>
                  <i className={`${card.icon} ${colors.icon} text-xl`}></i>
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}